import { PurposeRestriction } from './PurposeRestriction.js';
import { RestrictionType } from './RestrictionType.js';
import { Cloneable } from '../Cloneable.js';
export class PurposeRestrictionVector extends Cloneable {
    /**
 *
 *
 */
    bitLength = 0;
    /**
 *
 *
 */
    map = new Map();
    gvl_;
    has(hash) {
        return this.map.has(hash);
    }
    isOkToHave(restrictionType, purposeId, vendorId) {
        let result = true;
        /**
 *
 *
 *
 */
        if (this.gvl?.vendors) {
            const vendor = this.gvl.vendors[vendorId];
            if (vendor) {
                if (restrictionType === RestrictionType.NOT_ALLOWED) {
                    /**
 *
 *
 *
 *
 */
                    result = (vendor.legIntPurposes.includes(purposeId) || vendor.purposes.includes(purposeId));
                }
                else if (vendor.flexiblePurposes.length) {
                    switch (restrictionType) {
                        /**
 *
 *
 *
 */
                        case RestrictionType.REQUIRE_CONSENT:
                            result = (vendor.flexiblePurposes.includes(purposeId) && vendor.legIntPurposes.includes(purposeId));
                            break;
                        /**
 *
 *
 *
 */
                        case RestrictionType.REQUIRE_LI:
                            result = (vendor.flexiblePurposes.includes(purposeId) && vendor.purposes.includes(purposeId));
                            break;
                    }
                }
                else {
                    result = false;
                }
            }
            else {
                /*                        */
                result = false;
            }
        }
        /*                                                         */
        return result;
    }
    /**
 *
 *
 *
 *
 *
 */
    add(vendorId, purposeRestriction) {
        if (this.isOkToHave(purposeRestriction.restrictionType, purposeRestriction.purposeId, vendorId)) {
            const hash = purposeRestriction.hash;
            if (!this.has(hash)) {
                this.map.set(hash, new Set());
                this.bitLength = 0;
            }
            /**
 *
 *
 *
 */
            this.map.get(hash).add(vendorId);
        }
    }
    /**
 *
 *
 *
 *
 */
    restrictPurposeToLegalBasis(purposeRestriction) {
        const vendors = Array.from(this.gvl.vendorIds);
        const hash = purposeRestriction.hash;
        const lastEntry = vendors[vendors.length - 1];
        /**
 *
 */
        const values = [...Array(lastEntry).keys()].map((i) => i + 1);
        if (!this.has(hash)) {
            this.map.set(hash, new Set(values)); /*                                                                        */
            this.bitLength = 0;
        }
        else {
            for (let i = 1; i <= lastEntry; i++) {
                /**
 *
 *
 *
 */
                this.map.get(hash).add(i);
            }
        }
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
    getVendors(purposeRestriction) {
        let vendorIds = [];
        if (purposeRestriction) {
            const hash = purposeRestriction.hash;
            if (this.has(hash)) {
                vendorIds = Array.from(this.map.get(hash));
            }
        }
        else {
            const vendorSet = new Set();
            this.map.forEach((set) => {
                set.forEach((vendorId) => {
                    vendorSet.add(vendorId);
                });
            });
            vendorIds = Array.from(vendorSet);
        }
        return vendorIds.sort((a, b) => a - b);
    }
    getRestrictionType(vendorId, purposeId) {
        let rType;
        this.getRestrictions(vendorId).forEach((purposeRestriction) => {
            if (purposeRestriction.purposeId === purposeId) {
                if (rType === undefined || rType > purposeRestriction.restrictionType) {
                    rType = purposeRestriction.restrictionType;
                }
            }
        });
        return rType;
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 */
    vendorHasRestriction(vendorId, purposeRestriction) {
        let has = false;
        const restrictions = this.getRestrictions(vendorId);
        for (let i = 0; i < restrictions.length && !has; i++) {
            has = purposeRestriction.isSameAs(restrictions[i]);
        }
        return has;
    }
    /**
 *
 *
 *
 *
 */
    getMaxVendorId() {
        let retr = 0;
        this.map.forEach((set) => {
            retr = Math.max(Array.from(set)[set.size - 1], retr);
        });
        return retr;
    }
    getRestrictions(vendorId) {
        const retr = [];
        this.map.forEach((set, hash) => {
            if (vendorId) {
                if (set.has(vendorId)) {
                    retr.push(PurposeRestriction.unHash(hash));
                }
            }
            else {
                retr.push(PurposeRestriction.unHash(hash));
            }
        });
        return retr;
    }
    getPurposes() {
        const purposeIds = new Set();
        this.map.forEach((set, hash) => {
            purposeIds.add(PurposeRestriction.unHash(hash).purposeId);
        });
        return Array.from(purposeIds);
    }
    /**
 *
 *
 *
 *
 *
 */
    remove(vendorId, purposeRestriction) {
        const hash = purposeRestriction.hash;
        const set = this.map.get(hash);
        if (set) {
            set.delete(vendorId);
            /*                                                             */
            if (set.size == 0) {
                this.map.delete(hash);
                this.bitLength = 0;
            }
        }
    }
    /**
 *
 *
 *
 *
 */
    set gvl(value) {
        if (!this.gvl_) {
            this.gvl_ = value;
            /**
 *
 *
 */
            this.map.forEach((set, hash) => {
                const purposeRestriction = PurposeRestriction.unHash(hash);
                const vendors = Array.from(set);
                vendors.forEach((vendorId) => {
                    if (!this.isOkToHave(purposeRestriction.restrictionType, purposeRestriction.purposeId, vendorId)) {
                        set.delete(vendorId);
                    }
                });
            });
        }
    }
    /**
 *
 *
 *
 */
    get gvl() {
        return this.gvl_;
    }
    /**
 *
 *
 *
 */
    isEmpty() {
        return this.map.size === 0;
    }
    ;
    /**
 *
 *
 *
 */
    get numRestrictions() {
        return this.map.size;
    }
}
